import { Layout, Row, Col, Space, Typography, Button, Badge, Dropdown } from "antd";
import { ArrowLeftOutlined, EllipsisOutlined } from "@ant-design/icons";
import React from "react";
import { useTranslation } from "react-i18next";

export function StickyNavigationHeader({ headerTitle, onBackClick, actions }) {
    const { t } = useTranslation();

    // Normalize actions to an array we can map into a menu on mobile
    const actionItems = React.Children.toArray(actions).filter(Boolean);
    const menu = {
        items: actionItems.map((node, i) => ({
            key: String(i),
            // put original button/content inside the menu; AntD renders it fine
            label: <div className="min-w-[180px]">{node}</div>,
        })),
    };

    return (
        <Layout.Header
            style={{
                position: "sticky",
                top: 0,
                zIndex: 20,
                background: "rgba(255,255,255,0.85)",
                backdropFilter: "blur(6px)",
                borderBottom: "1px solid #f0f0f0",
                paddingInline: 12,
            }}
            className="!h-auto"
        >
            {/* Responsive two-row layout with safe wrapping */}
            <div
                className="mx-auto w-full"
                style={{ maxWidth: 1200 }}
            >
                <Row
                    align="middle"
                    justify="space-between"
                    gutter={[8, 8]}
                    wrap
                >
                    {/* LEFT: Back + badge + title (ellipsis) */}
                    <Col flex="auto" className="min-w-0">
                        <Space align="center" size={8} wrap>
                            {/* Compact back on mobile; text on md+ */}
                            <Button type="text" onClick={onBackClick} icon={<ArrowLeftOutlined />} className="!px-2" />
                            <Badge color="#7c3aed" />
                            <Typography.Title
                                level={5}
                                className="!mb-0"
                                ellipsis={{ tooltip: headerTitle }}
                                style={{ margin: 0, maxWidth: "100%" }}
                            >
                                {headerTitle}
                            </Typography.Title>
                        </Space>
                    </Col>

                    {/* RIGHT: Actions inline on md+, collapsed on mobile */}
                    <Col flex="none">
                        <div className="flex items-center gap-6">
                            {/* Inline actions for >= md screens */}
                            <div className="hidden md:flex items-center gap-8">
                                <Space size={8} wrap>{actionItems}</Space>
                            </div>

                            {/* Mobile “More” dropdown with all actions */}
                            {actionItems.length > 0 && (
                                <div className="md:hidden">
                                    <Dropdown menu={menu} trigger={["click"]} placement="bottomRight">
                                        <Button type="text" className="!px-2" icon={<EllipsisOutlined />} />
                                    </Dropdown>
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
            </div>
        </Layout.Header>
    );
}